/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCancel = createReactComponent("outline", "cancel", "IconCancel", [["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M18.364 5.636l-12.728 12.728", "key": "svg-1" }]]);

export { IconCancel as default };
//# sourceMappingURL=IconCancel.mjs.map
